<template>
  <div class="input-group">
    <div class="input-group-prepend">
      {{$t('cart.checkout.discount_code')}}:
    </div>
    <input type="text" class="form-control" v-model="code" @keyup.prevent.enter="apply" :disabled="coupon">
    <div class="input-group-append">
      <button v-if="coupon" class="btn w-100" type="button" @click.prevent="remove" :title="$t('cart.checkout.remove')">
        <div class="icon icon-close"></div>
      </button>
      <button v-else class="btn w-100" type="button" @click.prevent="apply" :title="$t('cart.checkout.confirm')">
        <div class="icon icon-check-mark"></div>
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapActions, mapState } = createNamespacedHelpers('cart')

export default {
  data () {
    return {
      code: ''
    }
  },

  computed: mapState(['coupon']),

  methods: {

    ...mapActions(['applyCoupon', 'removeCoupon']),

    apply () {
      this.code.length && this.applyCoupon({ code: this.code })
    },

    remove () {
      this.removeCoupon()
      this.code = ''
    }
  },

  mounted () {
    this.code = this.coupon ? this.coupon.koda : ''
  }
}
</script>

<style lang="scss" scoped>
input[type="text"] {
  height: auto;
}

.input-group-append {
  .icon-close {
    font-size: .7rem;
  }
}
</style>
